<template>
  <div v-if="response" class="request-response row">
    <div class="request col-12 col-md-5">
      <h3>Request</h3>
      <pre class="params">{{ params }}</pre>
    </div>
    <div class="response col-12 col-md-7">
      <h3>
        Response
        <button v-if="!showRawJson" @click="viewRawJson" type="button" class="btn btn-link pull-right">View raw JSON</button>
        <button v-else @click="viewJsonTree" type="button" class="btn btn-link pull-right">View JSON tree</button>
      </h3>
      <div v-if="response.ok" class="success">
        <div class="status">Status:<code class="bg-faded">{{ response.status }}</code><span class="time pull-right">Response time = {{ response.time }}s</span></div>
        <tree-view v-if="!showRawJson" :data="response.body" :options="{rootObjectKey: 'response', maxDepth: 3}" class="json"></tree-view>
        <pre v-else class="json raw">{{ response.body }}</pre>
      </div>
      <div v-else class="success">
        <div v-if="response.status" class="status">Status:<code class="bg-faded">{{ response.status }}</code></div>
        <p class="failure text-danger lead">API call failed</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ApiResponse',
  data () {
    return {
      showRawJson: false
    }
  },
  computed: {
    params () {
      return this.$store.state.api.params
    },
    response () {
      return this.$store.state.api.response
    }
  },
  methods: {
    viewRawJson () {
      this.showRawJson = true
    },
    viewJsonTree () {
      this.showRawJson = false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import '../../node_modules/bootstrap/scss/_variables';
.request-response {
  margin-top: 1rem;
  margin-bottom: 2rem;
}
h3 {
  margin-bottom: 12px;
}
.response .json, .request .params {
  background: $gray-lighter;
  padding: 1rem;
}
.response .json.raw {
  max-height: 1000px;
  overflow: auto;
}
.request .params {
  margin-top: 60px;
}
.status {
  font-size: 1.3rem;
  margin-bottom: 1rem;
}
.status code {
  margin-left: 1rem;
}
.failure {
  font-weight: bold;
}
.response {
  .tree-view-item {
    font-family: $font-family-monospace;
  }
  .tree-view-item-hint {
    color: #a5a3a3;
  }
}
</style>



// WEBPACK FOOTER //
// ApiRequestResponse.vue?139ce2c0